<mat-form-field class="dict-partners">
  <mat-label>{{label}}</mat-label>
  <mat-chip-list #chipList aria-label="Wybór partnerów" [required]="required">
    <mat-chip
      *ngFor="let option of selectedItems"
      (removed)="remove(option)"
      [matTooltip]="'ID: ' + option.recordId + ', NIP: ' + option.nip + ', REGON: ' + option.regon"
      matTooltipPosition="above"
    >
      {{option.shortName}}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    <input
      placeholder="Wyszukaj partnera..."
      #partnerInput
      [formControl]="partnerFilterCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList">
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let option of itemsToSelect" [value]="option">
      {{option.shortName}} (NIP: {{option.nip}}, REGON: {{option.regon}}, ID: {{option.recordId}})
    </mat-option>
  </mat-autocomplete>
  <button *ngIf="((control.value !== null
    && control.value.hasOwnProperty('length')
    && control.value.length > 0) || control.value)
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
